module.exports = __webpack_public_path__ + "img/allegiant-stadium-buyout-gal-6.1ca4dae3.jpg";